module.exports = __webpack_public_path__ + "media/Camera-Film03-1.538c2c00.mp3";